import { render, staticRenderFns } from "./SecondMenu.vue?vue&type=template&id=6585e83e&scoped=true&"
import script from "./SecondMenu.vue?vue&type=script&lang=js&"
export * from "./SecondMenu.vue?vue&type=script&lang=js&"
import style0 from "./SecondMenu.vue?vue&type=style&index=0&id=6585e83e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6585e83e",
  null
  
)

export default component.exports